export default __webpack_public_path__ + "static/media/100-BR-points.41a3fe03.png";